<mat-drawer-container autosize class="layout" [ngClass]="data.backgroundClassList" *ngIf="data$ | async as data" >

  <!-- Code to open drawer: <mat-icon aria-label="Sidebar" (click)="drawer.toggle()">menu</mat-icon> -->
  <mat-drawer #drawer mode="over" class="layout-drawer">

  </mat-drawer>

  <mat-drawer-content class="layout-content">
    <div class="layout-content" role="presentation">

      <header class="layout-content__header">
        <ng-content select=".header-before-content"></ng-content>
        <ofi-foundation-header
          *ngIf="data?.visibility?.header"
          [username]="username"
          [visibility]="data.visibility"
          [practice]="data.practice"
          [practices]="data.practices"
          [organization]="data.organization"
          [organizations]="data.organizations"
          [locale]="data.locale"
          [locales]="data.locales"
          [loading]="data.loading"
          [user]="data.user"
          [userMenuItems]="data.userMenuItems"
          (organizationSelectionChange)="onSelectOrganization($event)"
          (practiceSelectionChanged)="onSelectPractice($event)"
        >
          <button
            mat-icon-button class="left"
            *ngIf="data.visibility.sidebarButton"
            aria-label="Open Sidebar"
            data-qa="headerSidebarButton"
            (click)="drawer.toggle()"
          >
            <mat-icon alt="Open Sidebar Icon">menu</mat-icon>
          </button>
        </ofi-foundation-header>
        <ng-content select=".header-after-content"></ng-content>
      </header>

      <main class="layout-content__main">
        <ng-content select=".body-content"></ng-content>
        <router-outlet></router-outlet>
      </main>

      <footer class="layout-content__footer" *ngIf="data?.visibility?.footer">
        <ng-content select=".footer-before-content"></ng-content>
        <ofi-foundation-footer></ofi-foundation-footer>
        <ng-content select=".footer-after-content"></ng-content>
      </footer>

    </div>
  </mat-drawer-content>
</mat-drawer-container>
